import styled from "styled-components";

export const SpinnerIcon = styled.i`
 font-size: 1rem;
    margin-right: 4px;
`
